import React from "react";
import "./StatusPill.css";

/**
 * Lifecycle status pill. Status colors are intentionally fixed (a draft is
 * always orange) rather than surface-derived, for consistent recognition
 * wherever games are listed.
 *
 * Props:
 *   status: "draft" | "ready" | "in-progress" | "played" | "archived"
 *           | "awaiting-review" (alias "awaiting")
 *   size:   "sm" | "md"   (default "md")
 *   withDot: bool         (default true)
 */
const META = {
  draft: { label: "Draft", cls: "is-draft" },
  ready: { label: "Ready", cls: "is-ready" },
  "in-progress": { label: "In progress", cls: "is-inprogress" },
  played: { label: "Played", cls: "is-played" },
  archived: { label: "Archived", cls: "is-archived" },
  "awaiting-review": { label: "Awaiting review", cls: "is-awaiting" },
  awaiting: { label: "Awaiting review", cls: "is-awaiting" },
};

const StatusPill = ({ status = "draft", size = "md", withDot = true, className = "", ...rest }) => {
  const meta = META[status] || META.draft;
  return (
    <span className={`gx-pill ${meta.cls} gx-pill--${size} ${className}`} {...rest}>
      {withDot && <span className="gx-pill-dot" />}
      {meta.label}
    </span>
  );
};

export default StatusPill;
